import first from "lodash/first";
import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { usePreloadedQuery } from "react-relay";

import { useSearchContext } from "scmp-app/components/search/contexts";
import { query } from "scmp-app/components/search/search-result-panel";
import { DropdownMenu } from "scmp-app/components/search/search-result-panel/components/dropdown-menu";
import type { searchResultPanelQuery } from "scmp-app/queries/__generated__/searchResultPanelQuery.graphql";

import { getSectionOptionsWithCount } from "./helpers";

type Props = {
  className?: string;
  queryReference: PreloadedQuery<searchResultPanelQuery>;
};

export const SectionMenu: FunctionComponent<Props> = ({ className, queryReference }) => {
  const { sectionIds, setSectionIds } = useSearchContext();
  const data = usePreloadedQuery(query, queryReference);

  const options = getSectionOptionsWithCount(data);

  const selectedSectionOption = Array.isArray(sectionIds) ? (first(sectionIds) ?? "") : undefined;

  const isChangedOptionColor = selectedSectionOption !== "";

  return (
    <DropdownMenu
      className={className}
      isChangedOptionColor={isChangedOptionColor}
      onOptionSelect={sectionOption => {
        setSectionIds?.(sectionOption?.value ? [sectionOption.value] : []);
      }}
      options={options}
      placeholder="Section"
      selectedOptionValue={selectedSectionOption}
      withCount={!!options}
    />
  );
};

SectionMenu.displayName = "SectionMenu";
